import React from 'react';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';

import {
  LOGIN_PATH,
  BASE_PATH,
  ALCOHOL_PATH,
  ATTANDANCE_PATH,
  DRIVER_PATH,
  VEHICLE_PATH,
  DEVICE_PATH,
  Driver_ID_PATH,
  VEHICLE_ID_PATH,
  DRIVER_HEALTHCHECK_DETAIL,
  CLIENT_PATH,
  CLIENT_ID_PATH_EDIT,
  CLIENT_ID_PATH_VIEW,
  CLIENT_PATH_ADD,
  VEHICLE_USER_ID_PATH,
  SETTINGS_COMPANY_PATH,
} from './pathName';
import PrivateRoute from './PrivateRoute';
import NotFound from 'components/NotFound';
import Login from 'components/Login';
import Layout from 'components/layout/Layout';
import Dashboard from 'components/Dashboard';
import Alcohol from 'components/Alcohol';
import Attendance from 'components/Attendance';
import Driver from 'components/Driver';
import Vehicle from 'components/Vehicle';
import Device from 'components/Device';
import DriverView from 'components/Driver/DriverView/DriverView';
import ForgotPassword from 'components/Login/ForgotPassword/forgotPassword';
import ResetPassword from 'components/Login/ForgotPassword/resetPassword';
import NewPassword from 'components/Login/ForgotPassword/newPassword';
import VehicleInspectionDetails from 'components/Vehicle/VehicleInspectionDetails';
import DriverHealthCheckDetails from 'components/Driver/DriverView/DriverViewTable/DriverHealthCheckDetail';
import Client from 'components/Client';
import VehicleProfile from 'components/Vehicle/VehicleProfile';
import EditClient from 'components/Client/Action/EditClient';
import AddClient from 'components/Client/Action/AddClient';
import ViewClient from 'components/Client/Action/ViewClient';
import CompanySettings from 'components/Settings/CompanySettings';

// EV-137。配送先の編集画面で、保存していない変更があるときに画面内の移動を止める（useBlocker）
// ため、data router にする。経路・認証ガード・パスは BrowserRouter のときと同じ。
const routes = createRoutesFromElements(
  <>
        <Route path="*" element={<NotFound />} />
        {/* ADM-01。業務ルートは必ず認証ガードの下に置く。 */}
        <Route element={<PrivateRoute />}>
            <Route path="" element={<Layout />}>
            <Route path={BASE_PATH} element={<Dashboard />} />
            <Route path={ALCOHOL_PATH} element={<Alcohol />} />
            <Route path={ATTANDANCE_PATH} element={<Attendance />} />
            <Route path={DRIVER_PATH} element={<Driver />} />
            <Route path={Driver_ID_PATH} element={<DriverView />} />
          <Route
            path={DRIVER_HEALTHCHECK_DETAIL}
            element={<DriverHealthCheckDetails />}
          />
            <Route path={VEHICLE_PATH} element={<Vehicle />} />
          <Route
            path={VEHICLE_ID_PATH}
            element={<VehicleInspectionDetails />}
          />
            <Route path={VEHICLE_USER_ID_PATH} element={<VehicleProfile />} />
            <Route path={DEVICE_PATH} element={<Device />} />
            <Route path={CLIENT_PATH} element={<Client />} />
            <Route path={CLIENT_PATH_ADD} element={<AddClient />} />
            <Route path={CLIENT_ID_PATH_EDIT} element={<EditClient />} />
            <Route path={CLIENT_ID_PATH_VIEW} element={<ViewClient />} />
            <Route path={SETTINGS_COMPANY_PATH} element={<CompanySettings />} />
          </Route>
        </Route>
        <Route path={LOGIN_PATH} element={<Login />} />
        <Route path={`forgot-password`} element={<ForgotPassword />} />
        <Route path={`reset-password`} element={<ResetPassword />} />
        <Route path={`new-password`} element={<NewPassword />} />
  </>
);

// 読み込んだだけで履歴に触れないよう、最初の描画のときに作り、以後は同じものを使う
// （StrictMode の2回の初期化で、popstate を聞く router を2つ作らない）。
let appRouter: ReturnType<typeof createBrowserRouter> | null = null;
const getAppRouter = () => {
  if (appRouter === null) appRouter = createBrowserRouter(routes);
  return appRouter;
};

const AppRouter: React.FC = () => {
  return <RouterProvider router={getAppRouter()} />;
};

export default AppRouter;
